import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type Store = {
    open: boolean
    workflow: Record<string, unknown> | null
}

export const useActionDrawerStore = create<Store>()(
    devtools(
        (_set) => ({
            open: false,
            workflow: null,
        }),
        { name: 'ActionDrawerStore' },
    ),
)

export const useActionDrawerOpen = () => useActionDrawerStore((state) => state.open)
export const useActionDrawerWorkflow = () => useActionDrawerStore((state) => state.workflow)
export const closeActionDrawer = () => {
    useActionDrawerStore.setState({ open: false, workflow: null })
}
export const openActionDrawer = () => {
    useActionDrawerStore.setState({ open: true })
}

export const openActionDrawerWorkflow = (workflow: NonNullable<Store['workflow']>) => {
    useActionDrawerStore.setState({ open: true, workflow })
}
